// src/pages/certifications/Certifications.js
import React from "react";
import "./Certifications.css";
import { Fade } from "react-reveal";
import { certifications } from "../../portfolio";
import CertificationCard from "../../components/certificationCard/CertificationCard";
import { useTranslation } from "react-i18next";

function Certifications({ theme }) {
  const { t } = useTranslation();

  return (
    <div className="main" id="certs">
      <div className="certs-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="certs-header" style={{ color: theme.text }}>
            {t("certifications.pageTitle")}
          </h1>
        </Fade>
      </div>
      <div className="certs-body-div">
        {certifications.certifications.map((cert, index) => (
          <CertificationCard
            key={index}
            certificate={cert}
            theme={theme}
          />
        ))}
      </div>
    </div>
  );
}

export default Certifications;